import { IonModal, useIonViewWillLeave } from "@ionic/react";
import React, { useState } from "react";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { CONSTANTS } from "../../../../../../../../../constants";
import OnCallLookUpMainContent from "../../../../../../../../OnCallLookUp/OnCallLookUpMainContent/OnCalllookUpMainContent";
import { statusBoardService } from "../../../../../../../StatusBoard.service";
import { SupportStaffProviderContext } from "../../../../../../SupportStaff/SupportStaff";
import { AddProviderContext } from "../SBoardProvider";
import "./SBoardProviderModal.scss";
import classNames from "classnames/bind";
interface ContainerProps {
  showModal: boolean;
  onCancel: () => void;
  siteId?: any;
  pId?: any;
  isFromCaseHistory?: any;
  updateDetailsPage?: any;
  providerList?:any;
}

const SBoardProviderModal: React.FC<ContainerProps> = (props) => {
  const { t } = useTranslation("messages");
  const addProviderContextData = useContext(
    statusBoardService.selectedProviderPoupType
      ? SupportStaffProviderContext
      : AddProviderContext
  );
  let [canShowSearchResComp, setSearchResCompVisibility] =
    useState<boolean>(false);
  const setupdatedproviderListData = (dataFromProviderCard: any) => { };
  useIonViewWillLeave(() => {
    statusBoardService.selectedProviderPoupType = "";
  });

  const setSearchCompVisiblity = (dataFromProviderCard: any) => {
    if (dataFromProviderCard) {
      setSearchResCompVisibility(true);
    } else {
      setSearchResCompVisibility(false);
    }
  };

  const updateDetailsPage = (ProviderUpdated: any) => {
    if (ProviderUpdated) {
      props.updateDetailsPage(ProviderUpdated);
    }
  };

  const updateCaseDetails = () => {
    props.updateDetailsPage(props?.pId);
  };

  return (
    <IonModal
      isOpen={props.showModal}
      backdropDismiss={false}
      onDidDismiss={() => {
        setSearchResCompVisibility(false)
        props.onCancel();
      }}
      className={classNames({
        "sb-provider-modal": canShowSearchResComp ? true : false,
        "half-sb-modal-width": !canShowSearchResComp ? true : false,
        "sb-provider-modal-back": true,
      })}
    >
      <div className="sboard-card-container">
        <div className="provider-card-header">
          <span className="header-title">
            {addProviderContextData.popUptype ===
              CONSTANTS.PROVIDER_POPUPTYPE.PRIMARY_MD
              ? t("addPrimaryMD")
              : t("addProvider")}
          </span>
          <span
            className="icon-close close-ico"
            title={t("close")}
            onClick={() => {
              props.onCancel();
              if (props.updateDetailsPage) {
                updateCaseDetails();
              }
            }}
          ></span>
        </div>
        <div className="on-cal-cont">
          <OnCallLookUpMainContent
            updateProviderList={setupdatedproviderListData}
            showSearchResult={setSearchCompVisiblity}
            isResultPageDisplayed={() => { }}
            siteID={props.siteId}
            pId={props.pId}
            isFromCaseHistory={props.isFromCaseHistory}
            updateDetailsPage={updateDetailsPage}
            providerList={props?.providerList}
          />
        </div>
      </div>
    </IonModal>
  );
};

export default SBoardProviderModal;
